/*
 * LSD shopper-behaviour tracking (#263).
 *
 * Every listener here sits on `document`, so it also works on HTML the theme fetches
 * later, such as the quick-add pop-up, where inline <script> tags never run (#257).
 * Every event goes through window.lsdTrack (layout/theme.liquid), which sends nothing
 * until PostHog has loaded after the shopper accepts analytics cookies. No event here
 * carries a name, email, phone or address.
 */
(function () {
  if (window.__lsdTrackingBound) return;
  window.__lsdTrackingBound = true;

  function track(event, props) {
    try {
      if (window.lsdTrack) window.lsdTrack(event, props || {});
    } catch (e) {}
  }

  function product() {
    return (window.phContext && window.phContext.product) || null;
  }

  function cents(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? null : n;
  }

  // Sizes: size_selected for every real tap; size_unavailable_clicked as well for a sold-out
  // size. Moved here from snippets/variant-main-picker.liquid so quick-add taps count too.
  // isTrusted skips the synthetic change quick-add.js fires when it syncs the pop-up.
  document.addEventListener('change', function (e) {
    if (!e.isTrusted) return;
    var input = e.target && e.target.closest && e.target.closest('input[type="radio"][data-option-value-id]');
    if (!input) return;
    var picker = input.closest('variant-picker');
    if (!picker) return;
    var flag = input.dataset.pdpAvailable || input.dataset.optionAvailable;
    var available = flag === 'true';
    var props = {
      product_id: picker.dataset.productId,
      product_url: picker.dataset.productUrl,
      product_title: picker.dataset.productTitle || null,
      colour: picker.dataset.colour || null,
      size: input.value,
      variant_id: input.dataset.variantId || null,
      price: input.dataset.price || null,
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null,
      available: available,
      surface: input.closest('quick-add-dialog') ? 'quick_add' : 'pdp'
    };
    track('size_selected', props);
    if (!available) track('size_unavailable_clicked', props);
  });

  // Product page accordions (Product Details, Care, Shipping & Returns). The toggle event
  // also fires for rows opened by default, so only a toggle within 2 s of a real click on
  // that row's summary counts.
  var ACCORDION = '.accordion details[data-testid="accordion-details"]';
  document.addEventListener('click', function (e) {
    var summary = e.target && e.target.closest && e.target.closest(ACCORDION + ' > summary');
    if (summary) summary.parentElement.__lsdClickedAt = Date.now();
  }, true);
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details || !details.matches || !details.matches(ACCORDION) || !details.open) return;
    if (!details.__lsdClickedAt || Date.now() - details.__lsdClickedAt > 2000) return;
    details.__lsdClickedAt = 0;
    var p = product();
    if (!p) return;
    var summary = details.querySelector('summary');
    track('pdp_accordion_opened', {
      title: summary ? summary.textContent.replace(/\s+/g, ' ').trim().slice(0, 80) : null,
      product_id: p.product_id
    });
  }, true);

  // Product photos: one event each time the shopper reaches a photo further along than any
  // they had reached before on this page (a swipe back and forth is not counted twice).
  var furthestImage = 0;
  document.addEventListener('slideshow:select', function (e) {
    var d = e.detail || {};
    if (!d.userInitiated || !e.target.closest || !e.target.closest('media-gallery')) return;
    var p = product();
    if (!p || typeof d.index !== 'number' || d.index <= furthestImage) return;
    furthestImage = d.index;
    track('pdp_image_viewed', { index: d.index, trigger: d.trigger || null, product_id: p.product_id });
  });

  // Collection and search filters and sort. filter:update carries the whole new state, so
  // compare it with the state before to find what the shopper just changed.
  var lastParams = new URLSearchParams(window.location.search);
  document.addEventListener('filter:update', function (e) {
    var next = e.detail && e.detail.queryParams;
    if (!next || typeof next.getAll !== 'function') return;
    var pageType = /\/search/.test(window.location.pathname) ? 'search' : 'collection';
    var collection = (window.phContext && window.phContext.collection) || null;
    var base = { page_type: pageType, collection_handle: collection ? collection.collection_handle : null };
    var before = {};
    lastParams.forEach(function (v, k) { before[k + '=' + v] = true; });
    next.forEach(function (v, k) {
      if (k.indexOf('filter.') !== 0 || before[k + '=' + v]) return;
      track('collection_filter_applied', Object.assign({ filter: k, value: v }, base));
    });
    // The facets form always sends the checked sort, the default included, while the
    // landing URL has no sort_by, so a missing sort_by means the default sort.
    var defaultSort = document.querySelector('[data-default-sort-by]');
    var sortBefore = lastParams.get('sort_by') || (defaultSort && defaultSort.dataset.defaultSortBy) || null;
    var sortAfter = next.get('sort_by');
    if (sortAfter && sortAfter !== sortBefore) {
      track('collection_sort_changed', Object.assign({ sort_by: sortAfter }, base));
    }
    lastParams = new URLSearchParams(next.toString());
  });

  // Reading the cart figures the free-shipping bar renders (snippets/free-shipping-progress).
  function cartFigures(scope) {
    var bar = (scope || document).querySelector('.free-shipping-progress[data-total-cents]');
    if (!bar) return null;
    return {
      cart_value_cents: cents(bar.dataset.totalCents),
      threshold_cents: cents(bar.dataset.thresholdCents),
      item_count: cents(bar.dataset.itemCount),
      currency: bar.dataset.currency || null,
      free_shipping_reached: bar.classList.contains('free-shipping-progress--qualified')
    };
  }

  // The Checkout button in the cart drawer and on the cart page. The page is about to
  // leave, so this one event goes by sendBeacon (posthog-js docs, "Sending events before
  // a page unload").
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('#checkout');
    if (!btn) return;
    var drawer = btn.closest('cart-drawer-component');
    var props = Object.assign({ surface: drawer ? 'drawer' : 'cart_page' }, cartFigures(drawer || document) || {});
    try {
      if (window.posthog && window.posthog.__loaded) {
        window.posthog.capture('cart_checkout_clicked', props, { transport: 'sendBeacon', send_instantly: true });
      }
    } catch (err) {}
  }, true);

  // Free shipping reached: the first time in a session that a cart change turns the bar
  // from not reached to "unlocked". The drawer re-renders after cart:update, so look twice.
  var startFigures = cartFigures(document);
  var wasReached = !!(startFigures && startFigures.free_shipping_reached);
  function checkFreeShipping() {
    var figures = cartFigures(document);
    if (!figures) return;
    var before = wasReached;
    wasReached = figures.free_shipping_reached;
    if (before || !figures.free_shipping_reached) return;
    if (!(window.posthog && window.posthog.__loaded)) return;
    try {
      if (sessionStorage.getItem('lsd_fs_reached')) return;
      sessionStorage.setItem('lsd_fs_reached', '1');
    } catch (err) {
      if (window.__lsdFsReached) return;
      window.__lsdFsReached = true;
    }
    track('free_shipping_threshold_reached', figures);
  }
  document.addEventListener('cart:update', function () {
    setTimeout(checkFreeShipping, 400);
    setTimeout(checkFreeShipping, 1500);
  });

  // Add to Cart refused by Shopify (assets/product-form.js dispatches cart:error).
  document.addEventListener('cart:error', function (e) {
    var d = e.detail || {};
    var component = e.target && e.target.closest ? e.target.closest('product-form-component') : null;
    var form = component ? component.querySelector('form') : null;
    var idField = form && form.querySelector('[name="id"]');
    var message = d.data && d.data.message;
    track('add_to_cart_failed', {
      form_id: d.sourceId || null,
      product_id: component ? component.dataset.productId : null,
      variant_id: idField ? idField.value : null,
      message: typeof message === 'string' ? message.slice(0, 200) : null,
      surface: !component ? null : component.closest('quick-add-dialog') ? 'quick_add' : component.closest('product-card') ? 'card' : 'pdp'
    });
  });

  // Search: once the shopper stops typing for 1.5 s, how many products the search found.
  // The typed words are kept (Christian's choice, 7 Oct 2026) unless they look like an
  // email or a phone number, which are dropped.
  function bindSearch() {
    var results = document.querySelector('predictive-search-component [ref="predictiveSearchResults"]');
    var input = document.querySelector('predictive-search-component .search-input');
    if (!results || !input || results.__lsdObserved) return;
    results.__lsdObserved = true;
    var timer = null;
    var lastSent = '';
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var query = (input.value || '').trim().toLowerCase();
        if (!query || query === lastSent) return;
        lastSent = query;
        var looksPersonal = query.indexOf('@') !== -1 || /\d{7,}/.test(query.replace(/[\s\-()+.]/g, ''));
        var cards = results.querySelectorAll('.predictive-search-results__card--product');
        var count = 0;
        for (var i = 0; i < cards.length; i++) {
          if (!cards[i].closest('.recently-viewed-wrapper')) count++;
        }
        track('search_results_shown', {
          query: looksPersonal ? null : query.slice(0, 100),
          query_withheld: looksPersonal,
          results_count: count,
          no_results: !!results.querySelector('.predictive-search-results__no-results')
        });
      }, 1500);
    }).observe(results, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindSearch);
  else bindSearch();
})();
